import commonApi from "../../services/common";
import config from "../../config/configResolver";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    contentLanguages: {
      available: [],
      enabled: []
    },
    config,
    version: process.env.VUE_APP_VERSION,
    sessionRestoreCompleted: false,
    localizedLanguages: []
  },
  getters: {
    availableLanguageMap(state) {
      return Object.fromEntries(state.contentLanguages.available.map((x) => [x.languageCode, x]));
    },
    hasAnyUnsavedData(state, getters, rootState, rootGetters) {
      let result = false;
      const dirtyKeys = Object.keys(rootGetters).filter((x) => x.includes("hasUnsavedData"));

      dirtyKeys.forEach((x) => {
        result ||= rootGetters[x];
      });

      return result;
    },
    hasAnyUploadInProgress(state, getters, rootState, rootGetters) {
      let result = false;
      const dirtyKeys = Object.keys(rootGetters).filter((x) => x.includes("hasUploadInProgress"));

      dirtyKeys.some((x) => {
        return (result ||= rootGetters[x]);
      });

      return result;
    }
  },
  mutations: {
    "update-available-content-languages"(state, args) {
      state.contentLanguages.available = args;
      state.contentLanguages.enabled = [args[0]];
    },
    "update-enabled-content-languages"(state, args) {
      state.contentLanguages.enabled = args;
    },
    "update-localized-content-languages"(state, args) {
      state.localizedLanguages = args;
    },
    "set-localized-boolean-values"(state, args) {
      state.localizedBooleanValues = args.data;
    }
  },
  actions: {
    loadLanguages: async function (context) {
      const languages = await commonApi.getLanguages();
      const languageMap = _.keyBy(languages, "languageId");
      languages.forEach((lang) => {
        const fallback = languageMap[lang.fallbackId];
        lang.fallbackLanguageCode = fallback ? fallback.languageCode : "";
      });
      context.commit("update-available-content-languages", languages);
      const selectedLanguages = (context.rootState.userSettings.WebClientDataLanguages || "").split(",");
      let selected = languages.filter((x) => selectedLanguages.some((y) => y == x.languageCode));
      selected = _.sortBy(selected, (x) => selectedLanguages.indexOf(x.languageCode));
      const missingSelectedLanguages = selectedLanguages.filter((x) => !selected.some((s) => s.languageCode === x));
      for (let i = 0; i < missingSelectedLanguages.length; i++) {
        const firstFreeLanguage = languages.find((lang) => !selected.some((x) => x.languageId === lang.languageId));
        if (firstFreeLanguage) {
          selected.push(firstFreeLanguage);
        }
      }

      if (selected.length) context.commit("update-enabled-content-languages", selected);
    },
    changeContentLanguages: async function (context, lang) {
      const languages = _.clone(context.state.contentLanguages.enabled);

      if (lang.index < 0 || (lang.index >= languages.length && !lang.value)) return;

      if (!lang.value) languages.splice(lang.index, 1);
      else if (lang.index < languages.length) languages.splice(lang.index, 1, lang.value);
      else if (lang.index >= languages.length) languages.push(lang.value);

      context.commit("update-enabled-content-languages", languages);
      context.dispatch("saveUserSettings", { WebClientDataLanguages: languages.map((x) => x.languageCode).join(",") }, { root: true });
    },
    loadLocalizedLanguages: async function (context, lang) {
      const localizedLanguages = await commonApi.getLanguagesWithLocalizedName(lang);
      context.commit("update-localized-content-languages", localizedLanguages);
    },
    loadLocalizedBooleanValuesIfNecessary: async function ({ state, commit }) {
      if (!state.localizedBooleanValues || Object.keys(state.localizedBooleanValues) === 0) {
        const languages = state.contentLanguages.available.map((lang) => lang.languageCode);
        const localizedBooleanValuesData = await commonApi.getLocalizedBooleanValues(languages);
        const localizedBooleanValues = Object.fromEntries(
          languages.map((lang) => {
            const entriesForLanguage = localizedBooleanValuesData.flatMap((entry) => entry[lang] ?? []);
            return [lang, entriesForLanguage];
          })
        );
        commit("set-localized-boolean-values", { data: localizedBooleanValues });
      }
    }
  }
};
